import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";

import watermarkUrl from "../WOW-watermark.png";

import { styles } from "./stream-watermark.css";

@customElement("wow-stream-watermark")
export class WowStreamWatermark extends LitElement {
  static override styles = styles;

  override render() {
    return html`<img class="watermark" src=${watermarkUrl} alt="" />`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "wow-stream-watermark": WowStreamWatermark;
  }
}
